module.exports = __webpack_public_path__ + "static/logo-2ae9602fb0ff2e9bd4a03ceb8d61ea83.svg";